import Vue from 'vue'
import Vuex from 'vuex'
import { getRandomAesKey, ls, decrypt } from '@/utils/tool'
import { getInfo } from '@/api/user'
import { base_url } from '@/utils/request'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    url: base_url,
    LOADING: false,
    relationRecords: [],
    payStatus: false,
    msgCount: 0,
    wxlogin: false
  },
  mutations: {
    setRelationRecords(state, relationRecords) {
      state.relationRecords = relationRecords
    },
    setToken(state, token) {
      state.token = token
      sessionStorage.setItem('h5token', token)
    },
    changeMsgCount(state, count) {
      state.msgCount = count
    },
    changeWxLogint(state, wxlogin) {
      state.wxlogin = wxlogin
    },
    showLoading(state) {
      state.LOADING = true
    },
    hideLoading(state) {
      state.LOADING = false
    },
    payStatus(state, payStatus) {
      state.payStatus = payStatus
    }
  },
  actions: {
    setToken({ commit }, token) {
      return new Promise((resolve) => {
        commit('setToken', token)
        resolve()
      })
    },
    setRelationRecords({ commit }) {
      var key = getRandomAesKey()
      return new Promise((resolve, reject) => {
        getInfo({ token: ls.get('token'), key })
          .then((resUser) => {
            if (resUser) {
              console.log(resUser)
              var data = JSON.parse(
                decrypt(resUser.data, key.slice(0, 16), key.slice(16))
              )
              ls.set('sysUser', data)
              console.log('设置用户===', data)
              commit('setRelationRecords', data.relationRecords || [])
              resolve()
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  },
  modules: {}
})
